export default {
  superDesktop: 'Relatório',
  appNotifications: 'Notificações de aplicativos',
  home: 'Casa',
  peopleDirectory: 'Pessoas',
  peopleList: 'Listas',
  listDetails: 'Detalhes da lista',
  roles: 'Papéis',
  conversations: 'Conversas',
  conversationMetrics: 'Métricas de conversas',
  conversationSettings: 'Configurações de conversas',
  businesses: 'Empresas',
  businessDetails: 'Detalhes de negócios',
  campaigns: 'Campanhas',
  newSms: 'Novo SMS',
  newCampaign: 'Nova campanha',
  campaignDetails: 'Detalhes da campanha',
  triggers: 'Gatilhos',
  notifications: 'Notificações',
  speechToText: 'Discurso para projetos de texto',
  authenticator: 'Autenticador',
  forms: 'Forms',
  companyNotFound: 'Nenhuma empresa foi encontrada',
  upToDateNotifications: 'Vsocê está em dia com suas notificações',
  /* Events */
  events: 'Eventos',
  eventDetail: 'Detalhe do evento',
  assistants: 'Assistentes',
  promotors: 'Promotores',
  productsCategories: 'Categorias de produtos',
  products: 'Produtos',
  places: 'Lugares',
  /* ORDERS */
  clients: 'Clientes',
  colors: 'Cores',
  containerTypes: 'Tipos de Containers',
  purchases: 'Compras',
  purchaseDetail: 'Detalhe de Compra',
  sellers: 'Vendedores',
  suppliers: 'Fornecedores',
  /* END ORDERS */
  settings: 'Configurações',
  details: 'Detalhes',
  administrators: 'Administradores',
  billing: 'Faturamento',
  payments: 'Pagamentos',
  creditCards: 'Cartões de Crédito',
  newApp: 'Nova aplicação',
  newCompany: 'Nova Empresa',
  newPage: 'Nova Página',
  servicesPerPage: 'Serviços por página',
  balance: 'Equilíbrio',
  loadingTariffs: 'carregando tarifas',
  noTariffsOnTheListYet: 'Ainda não há tarifas na lista.',
  shortenLink: 'Encurtar o link',
  addCreditCart: 'Adicionar cartão de crédito',
  addCard: 'Adicionar cartão',
  load: 'Carga',
  changePassword: 'Mudar senha',
  exit: 'Saída',
  support: 'Apoio',
  /* TOOLBAR CARD */
  services: 'Serviços',
  value: 'Valor',
  addCreditCard: 'Add credit card',
  createAplication: ' Criar aplicativo'
}
